// src/components/common/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <span className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  if (roles && !roles.some(r => user.roles?.includes(r))) {
    return <Navigate to="/calculator" replace />;
  }

  return children;
};

export default ProtectedRoute;
